import React from "react";
import { Helmet } from "react-helmet-async";

function Seo({ title, description, keywords, canonical, noindex }) {
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex" : "index, follow"} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
}

export default Seo;
